export default __webpack_public_path__ + "static/1860-327eb9e88ac5b90be4335b9be6940771.gif";